import React, { forwardRef } from 'react'
import { cn } from "@/lib/utils"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip"

interface IconWithTooltipProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: React.ReactNode
  tooltip: string
  isClickable?: boolean
}

export const IconWithTooltip = forwardRef<HTMLDivElement, IconWithTooltipProps>((
  {
    icon,
    tooltip,
    isClickable = false,
    className,
    ...props
  }: IconWithTooltipProps,
  ref
) => {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          <div
            ref={ref}
            className={cn(
              "inline-flex items-center justify-center",
              isClickable && "cursor-pointer transition-colors hover:text-primary",
              !isClickable && "text-muted-foreground",
              className
            )}
            {...props}
          >
            {icon}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p className="text-sm">{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
});

IconWithTooltip.displayName = 'IconWithTooltip';
